import type { BankingStateModel } from '@stores/banking/banking-ngrx.reducer';

import { createSelector } from '@ngrx/store';
import { bankingKey } from '@stores/banking/banking-ngrx.reducer';

export const selectBankingState = (state: any): BankingStateModel => state[bankingKey];

export const user = createSelector(selectBankingState, (state) => {
  return state.user;
});
export const bankAccount = createSelector(selectBankingState, (state) => {
  return state.bankAccount;
});
export const eligibility = createSelector(selectBankingState, (state) => {
  return state.eligibility;
});
export const bankingPartner = createSelector(selectBankingState, (state) => {
  return state.bankingPartner;
});
